// Leitura do link da página de pagamento HiperPay.
//
// O link chega pronto do HiperPay (é ele quem monta a URL); aqui só separamos as
// partes que interessam na tela: o host, pra mostrar de onde é, e o código final,
// que é o identificador público da página — o que a equipe usa pra achar a
// cobrança no HiperPay quando o cliente reclama.

// Último segmento da URL, sem query string nem âncora.
export function linkCode(link) {
  const limpo = String(link || '').split('?')[0].split('#')[0]
  const segmento = limpo.replace(/\/+$/, '').split('/').pop()
  return segmento || ''
}

// Host da URL. Sem link (ou com link malformado), devolve o domínio padrão só
// para a barra de endereço do preview não ficar vazia.
export function hostFromLink(link, padrao = 'pay.hipersend.com.br') {
  const achado = String(link || '').match(/^https?:\/\/([^/]+)/i)
  return achado ? achado[1] : padrao
}

// Só aceitamos http(s) para abrir/copiar. Um valor que não seja URL (código
// solto, texto do ERP, javascript:) não vira link clicável na tela.
export function isLinkAbrivel(link) {
  return /^https?:\/\/[^\s]+$/i.test(String(link || '').trim())
}
